import PropTypes from 'prop-types';
import React from 'react';
import DeviceUngroupedView from '../DeviceUngroupedView';
import { Box } from 'signoxe/components/layout';
import './styles.scss';

const offlineOnly = localStorage.getItem('offlineOnly')

const DeviceUngroupedList = ({
  deviceGroups,
  dropdownGroups,
  screenshotsEnabled,
  smartBoardEnabled,
  deviceReportEnabled,
  onDeviceChange,
  rebootEnabled,
  RestartAppEnabled,
  ClearUnusedMediaEnabled,
  offlineEnabled,
  delayDownloadEnabled,
  onGroupFeedChange,
  onDeviceGroupDelete,
  onDeviceGroupChange,
  onClickSchedule,
  onPriorityMessageActivate,
  onPriorityMessageChange,
  onPriorityMessageDeactivate,
  queryString,
  handleUserReport,
  deviceTags,
}) => (
  

  <div className="device-groups">
    <Box direction="column" className="device-group card depth-1">
      <table className="device-list stack unstriped">
        <thead>
            {offlineOnly === 'false' ?
            <tr className="list-headings depth-1">
              <th>Device Name</th>
              {screenshotsEnabled && <th className="screenshots-header">Screenshots</th>}
              {offlineEnabled && <th>Offline</th>}
              {delayDownloadEnabled && <th>Device State</th>}
              <th>Last Ping</th>
              <th>Manage Content</th>
              <th>More Options</th>
              <th>Assign Group</th>
            </tr>
            :
            <tr className="list-headings depth-1">
              <th>Device Name</th>
              <th>Assign Group</th>
              <th></th>
            </tr>}
        </thead>
          {deviceGroups.map(group => {
            if (group.devices.length > 0) {
              return (
              <DeviceUngroupedView key={group.id}
            handleUserReport={handleUserReport}
            screenshotsEnabled={screenshotsEnabled}
            smartBoardEnabled={smartBoardEnabled}
            deviceReportEnabled={deviceReportEnabled}
            rebootEnabled={rebootEnabled}
            RestartAppEnabled={RestartAppEnabled}
            ClearUnusedMediaEnabled={ClearUnusedMediaEnabled}
            offlineEnabled={offlineEnabled}
            delayDownloadEnabled={delayDownloadEnabled}
            deviceGroup={group}
            groupList={deviceGroups}
            dropdownGroups={dropdownGroups}
            onDeviceChange={onDeviceChange}
            onDeviceGroupDelete={onDeviceGroupDelete}
            onDeviceGroupChange={onDeviceGroupChange}
            onPriorityMessageActivate={onPriorityMessageActivate}
            onPriorityMessageChange={onPriorityMessageChange}
            onPriorityMessageDeactivate={onPriorityMessageDeactivate}
            onGroupFeedChange={onGroupFeedChange}
            onClickSchedule={onClickSchedule} 
            searchString={queryString}
              deviceTags={deviceTags}
            />
            );
          } else {
            return null; // Or any other action you want to take for empty device groups
          }
        })}
      </table>
    </Box>
  </div>
);

DeviceUngroupedList.propTypes = {
  queryString: PropTypes.string.isRequired,
  deviceGroups: PropTypes.array.isRequired,
  dropdownGroups: PropTypes.array.isRequired,
  screenshotsEnabled: PropTypes.bool,
  smartBoardEnabled: PropTypes.bool,
  deviceReportEnabled: PropTypes.bool,
  rebootEnabled: PropTypes.bool,
  RestartAppEnabled: PropTypes.bool,
  ClearUnusedMediaEnabled: PropTypes.bool,
  offlineEnabled: PropTypes.bool,
  delayDownloadEnabled: PropTypes.bool,
  onDeviceChange: PropTypes.func.isRequired,
  onDeviceGroupDelete: PropTypes.func.isRequired,
  onDeviceGroupChange: PropTypes.func.isRequired,
  onGroupFeedChange: PropTypes.func.isRequired,
  onClickSchedule: PropTypes.func.isRequired,
  onPriorityMessageChange: PropTypes.func.isRequired,
  onPriorityMessageActivate: PropTypes.func.isRequired,
  onPriorityMessageDeactivate: PropTypes.func.isRequired,
  handleUserReport:PropTypes.func.isRequired,
  deviceTags: PropTypes.object,
};

export default DeviceUngroupedList;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/DeviceUngroupedList/index.js